module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he authors would like to thank the following for their contributions, advice, suggestions, permissions and loan of materials, without which this book could not have been compiled: Nick Baines, Peter Bishop, John Boyle, Kay Butler, Chris Cox, Anthony Dawson, Marc Dobson, Bob Essery, Ben Fraser, Alan Garner, John Hewlett, David Mills, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Railway Modeller")]), _vm._v(", Roger Pidgeon, Ruth and Graham Powell, Nick Salzman, Graham Varley, Cor de Jong, Paul Marchese, Ian Wright and David Viewing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We also thank our wives Margaret and Jane for their encouragement and forbearance during the writing of the book.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Peter Chatham."), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(" Stephen Weston")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73779d2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_ack.vue
// module id = 69
// module chunks = 0